import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { useState } from "react";

import { LinkCard } from "~/components/link-card";
import { ChildAcquisitionPartnerDialog } from "~/components/parent/child-acquisition-partner-dialog";
import { ChildAcquisitionPartnerTable } from "~/components/parent/child-acquisition-partner-table";
import { Page, PageHeader, Section } from "~/components/shell/page";
import { isParent, meQueryOptions } from "~/lib/api/me";
import { childAcquisitionPartnersQueryOptions } from "~/lib/api/partners";
import { enrollLink } from "~/lib/links";

export const Route = createFileRoute("/_authenticated/partners")({
  beforeLoad: ({ context }) => {
    if (!isParent(context.partner)) throw redirect({ to: "/overzicht" });
  },
  loader: async ({ context }) => {
    await context.queryClient.query(childAcquisitionPartnersQueryOptions());
  },
  component: PartnersPage,
});

function PartnersPage() {
  const { data: partner } = useSuspenseQuery(meQueryOptions());
  const { data: childPartners } = useSuspenseQuery(
    childAcquisitionPartnersQueryOptions(),
  );
  const [selectedId, setSelectedId] = useState<string>();

  return (
    <Page>
      <PageHeader title="Partners">
        De installateurs die onder {partner.companyName} klanten aanbrengen. Installateurs
        schrijven zichzelf in via de gedeelde link; jij hoeft niets aan te maken of te
        onderhouden.
      </PageHeader>

      <LinkCard
        title="Gedeelde aanmeldlink"
        description="Stuur deze link naar je installateurs. Wie zich inschrijft, krijgt direct een eigen referrallink voor zijn klanten."
        link={enrollLink(partner.enrollCode ?? "")}
        buttonLabel="Kopieer link"
        count={childPartners.length}
        countLabel="via deze link ingeschreven"
      />

      <Section
        title="Ingeschreven installateurs"
        description="Klik op een partner voor details en aandeelverdeling."
      >
        <ChildAcquisitionPartnerTable
          childPartners={childPartners}
          onSelect={(childPartner) => setSelectedId(childPartner.id)}
        />
      </Section>

      <ChildAcquisitionPartnerDialog
        childPartner={childPartners.find(
          (childPartner) => childPartner.id === selectedId,
        )}
        onClose={() => setSelectedId(undefined)}
      />
    </Page>
  );
}
